"use client"

import React from "react"
import { useState, useEffect, useCallback } from "react"
import {
  Container,
  Grid,
  Card,
  CardContent,
  Button,
  TextField,
  Select as MaterialUISelect,
  MenuItem,
  FormControl,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  InputAdornment,
  IconButton,
  Breadcrumbs,
  Link,
  CircularProgress,
} from "@material-ui/core"
import { Search as SearchIcon, GetApp as ExportIcon, CloudUpload as UploadIcon, Edit as EditIcon } from "@material-ui/icons"
import axios from "axios"
import * as FileSaver from "file-saver"
import * as XLSX from "xlsx"
import ReactSelect from "react-select";
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from "@material-ui/core/styles";

// Keep your existing imports exactly as they are
import { API_BASE_URL, API_BASE_URL_2, API_KEY, getCookie, sessionExpired } from "../../constants/utilis"
import uploadFile from "./s3/s3.upload"

// Keep the existing formatDate function
function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear()
  if (month.length < 2) month = "0" + month
  if (day.length < 2) day = "0" + day
  return [year, month, day].join("-")
}

// Keep the existing custom styles
const customStyles1 = {
  control: (base) => ({
    ...base,
    height: 53,
    minHeight: 35,
    backgroundColor: "white",
    overflow: "hidden",
    width: 250,
  }),
}

const useStyles = makeStyles({
  tableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#fafafa",
    },
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  },
})


const PendingCaseNew = () => {
  // State management - converting all class state to useState hooks
  const [firebaseData, setFirebaseData] = useState([])
  const [firebaseData1, setFirebaseData1] = useState([])
  const [totalFilteredData, setTotalFilteredData] = useState([])
  const [videoName, setVideoName] = useState("")
  const [menu, setMenu] = useState("Select")
  const [successMsg, setSuccessMsg] = useState(false)
  const [agents, setAgents] = useState([])
  const [banks, setBanks] = useState([])
  const [products, setProducts] = useState([])
  const [bank, setBank] = useState("")
  const [product, setProduct] = useState("")
  const [agentName, setAgentName] = useState("")
  const [agent, setAgent] = useState("")
  const [topIndex, setTopIndex] = useState("-1")
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [applicationId, setApplicationId] = useState("")
  const [searchQuery, setSearchQuery] = useState("")
  const [loading, setLoading] = useState(false)

  // Modal state
  const [openModal, setOpenModal] = useState(false)
  const [modalData, setModalData] = useState({
    applicationId: "",
    customerName: "",
    mobileNumber: "",
    productName: "",
    rvAddress: "",
    bvAddress: "",
    pvAddress: "",
  })

  // Pagination
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(30)
  const [totalRecords, setTotalRecords] = useState(0)
  const [queryParams, setQueryParams] = useState({})
  const [pages] = useState([30, 50, 100, 300, 500])

  // File upload and other states
  const [selectedFile, setSelectedFile] = useState(null)
  const [selectedMulti, setSelectedMulti] = useState([])
  const [appointTime, setAppointTime] = useState({})

  const classes = useStyles()
  
  // Get user permissions
  const userBank = localStorage.getItem("bank") || sessionStorage.getItem("bank") || ""
  const userPosition = sessionStorage.getItem("position") || ""
  const isSuperAdmin = userBank.includes("SUPER ADMIN") || userPosition === "Super Admin"

  // Handle non-200 responses
  const handleNon200Response = useCallback((error, functionIndex) => {
    if (error.response?.status === 401 && error.response?.data?.message === "User Not authenticated") {
      sessionExpired()
    }
  }, [])

  // Fetch initial data
  const fetchList = useCallback(async () => {
    setLoading(true);
    const state = localStorage.getItem("state") || sessionStorage.getItem("state") || ""
    const bankData = localStorage.getItem("bank") || sessionStorage.getItem("bank") || ""

    let banks = localStorage.getItem("bank")
      if (banks === null) {
          banks = sessionStorage.getItem("bank")
      }

    const today = new Date();
    const endDate = today.toISOString().split('T')[0];
    const startDate = today.toISOString().split('T')[0];

    console.log("Stattt", startDate, endDate);

    const jsonData = {
      state: state.split(",").slice(0, -1),
      startDate,
      endDate,
      // bank: bankData.split(",").slice(0, -1),
    }

    if (!bankData.includes("SUPER ADMIN")) {
      jsonData.bank = bankData.split(",").slice(0, -1)
    }

    setQueryParams(jsonData)

    jsonData.pagination = true
    jsonData.pageSize = rowsPerPage
    jsonData.pageCount = page + 1

    try {
      const response = await axios.post(`${API_BASE_URL}/auth/report/pendingCase`, jsonData, {
        headers: {
          apikey: API_KEY,
          Authorization: `Bearer ${getCookie("at")}`,
          "Content-Type": "application/json",
        },
      })

      if (response.status === 200) {
    console.log('Datatata', response.data.caseList);

        setFirebaseData(response.data.caseList || [])
        setTotalFilteredData(response.data.totalFilteredData || [])
        setTotalRecords(response.data.totalRecords || 0)
        setLoading(false);
      }
    } catch (error) {
      console.error(error)
      handleNon200Response(error, "1")
      setLoading(false);
    }
    console.log('Datatata22222', totalRecords);

  }, [page, rowsPerPage, handleNon200Response])

  // Fetch banks, products, and agents
  useEffect(() => {
    const fetchInitialData = async () => {
      const state = localStorage.getItem("state") || sessionStorage.getItem("state") || ""

      try {
        // Fetch banks
        const banksResponse = await axios.get(`${API_BASE_URL}/auth/bank`, {
          headers: {
            apikey: API_KEY,
            Authorization: `Bearer ${getCookie("at")}`,
          },
        })
        setBanks(banksResponse.data || [])

        // Fetch products
        const productsResponse = await axios.get(`${API_BASE_URL}/auth/loanproduct`, {
          headers: {
            apikey: API_KEY,
            Authorization: `Bearer ${getCookie("at")}`,
          },
        })
        setProducts(productsResponse.data || [])

        // Fetch agents
        let agentsResponse
        if (state.includes("SUPER ADMIN")) {
          agentsResponse = await axios.get(`${API_BASE_URL}/auth/activeApprovedAgents`, {
            headers: {
              apikey: API_KEY,
              Authorization: `Bearer ${getCookie("at")}`,
            },
          })
        } else {
          const jsonData = {
            state: state.split(",").slice(0, -1),
            agentOnlineStatus: "Active",
          }
          agentsResponse = await axios.post(`${API_BASE_URL}/auth/report/approvedAgents`, jsonData, {
            headers: {
              apikey: API_KEY,
              Authorization: `Bearer ${getCookie("at")}`,
              "Content-Type": "application/json",
            },
          })
        }

        const ags = []
        for (let i = 0; i < agentsResponse.data.length; i++) {
          if (agentsResponse.data[i].agentid !== undefined) {
            const dict = {
              label: `${agentsResponse.data[i].agentid}-${agentsResponse.data[i].name}`,
              value: agentsResponse.data[i]._id,
            }
            ags.push(dict)
          }
        }
        setAgents(ags)
      } catch (error) {
        console.error(error)
      }
    }

    fetchInitialData()
    fetchList()
  }, [fetchList])

  // Handle pagination
  const handleChangePage = async (event, newPage) => {
    setPage(newPage)

    const jsonData = { ...queryParams }
    jsonData.pagination = true
    jsonData.pageSize = rowsPerPage
    jsonData.pageCount = newPage + 1

    try {
      const response = await axios.post(`${API_BASE_URL}/auth/report/pendingCase`, jsonData, {
        headers: {
          apikey: API_KEY,
          Authorization: `Bearer ${getCookie("at")}`,
          "Content-Type": "application/json",
        },
      })

      if (response.status === 200) {
        setFirebaseData(response.data.caseList || [])
        setTotalFilteredData(response.data.totalFilteredData || [])
        setTotalRecords(response.data.totalRecords || 0)
      }
    } catch (error) {
      console.error(error)
      handleNon200Response(error, "98")
    }
  }

  const handleChangeRowsPerPage = async (event) => {
    const newRowsPerPage = Number.parseInt(event.target.value, 10)
    setRowsPerPage(newRowsPerPage)
    setPage(0)

    const jsonData = { ...queryParams }
    jsonData.pagination = true
    jsonData.pageSize = newRowsPerPage
    jsonData.pageCount = 1

    try {
      const response = await axios.post(`${API_BASE_URL}/auth/report/pendingCase`, jsonData, {
        headers: {
          apikey: API_KEY,
          Authorization: `Bearer ${getCookie("at")}`,
          "Content-Type": "application/json",
        },
      })

      if (response.status === 200) {
        setFirebaseData(response.data.caseList || [])
        setTotalFilteredData(response.data.totalFilteredData || [])
        setTotalRecords(response.data.totalRecords || 0)
      }
    } catch (error) {
      console.error(error)
      handleNon200Response(error, "99")
    }
  }

  // Handle product filter submit
  const handleSubmit = async (e) => {
    e.preventDefault()

    const state = localStorage.getItem("state") || sessionStorage.getItem("state") || ""
    const bankData = localStorage.getItem("bank") || sessionStorage.getItem("bank") || ""

    const jsonData = {
      state: state.split(",").slice(0, -1),
    }

    if (!bankData.includes("SUPER ADMIN")) {
      jsonData.bank = bankData.split(",").slice(0, -1)
    }

    if (product !== "") {
      jsonData.product = product
    }

    setQueryParams(jsonData)

    jsonData.pagination = true
    jsonData.pageSize = rowsPerPage
    jsonData.pageCount = page + 1

    try {
      const response = await axios.post(`${API_BASE_URL}/auth/report/pendingCase`, jsonData, {
        headers: {
          apikey: API_KEY,
          Authorization: `Bearer ${getCookie("at")}`,
          "Content-Type": "application/json",
        },
      })

      if (response.status === 200) {
        setFirebaseData(response.data.caseList || [])
        setTotalFilteredData(response.data.totalFilteredData || [])
        setTotalRecords(response.data.totalRecords || 0)
      }
    } catch (error) {
      console.error(error)
      handleNon200Response(error, "2")
    }
  }

  // Handle date filter
  const handleFilter = async (e) => {
    e.preventDefault()

    const state = localStorage.getItem("state") || sessionStorage.getItem("state") || ""
    const banks = localStorage.getItem("bank") || sessionStorage.getItem("bank") || ""

    const jsonData = {
      state: state.split(",").slice(0, -1),
      startDate,
      endDate,
      bank: bank,
    }

    console.log("bnckdcmd", banks)

    if (banks !== "" || !banks.includes("SUPER ADMIN")) {
      if (bank === "DMI FINANCE PRIVATE LIMITED") { // select field value
        jsonData.bank = ["DMI FINANCE PRIVATE LIMITED", "DMI FINANCIAL PRIVATE LIMITED", "DMI Finance Pvt. Ltd."]
      } else {
        jsonData.bank = bank || banks.split(",").slice(0, -1)
      }
    }

    if(banks.includes("SUPER ADMIN")) {
      if (!startDate) delete jsonData.startDate
      if (!endDate) delete jsonData.endDate
      if (!bank) delete jsonData.bank
    }

    if (!startDate) delete jsonData.startDate
    if (!endDate) delete jsonData.endDate
    // if (banks.includes("SUPER ADMIN")) delete jsonData.bank

    setQueryParams(jsonData)

    jsonData.pagination = true
    jsonData.pageSize = rowsPerPage
    jsonData.pageCount = page + 1

    try {
      const response = await axios.post(`${API_BASE_URL}/auth/report/pendingCase`, jsonData, {
        headers: {
          apikey: API_KEY,
          Authorization: `Bearer ${getCookie("at")}`,
          "Content-Type": "application/json",
        },
      })

      if (response.status === 200) {
        setFirebaseData(response.data.caseList || [])
        setTotalFilteredData(response.data.totalFilteredData || [])
        setTotalRecords(response.data.totalRecords || 0)
      }
    } catch (error) {
      console.error(error)
      handleNon200Response(error, "3")
    }
  }

  // Search by application ID
  const searchByApplicationId = async () => {
    if (applicationId === "") {
      alert("Enter Application ID")
      return
    }

    const state = localStorage.getItem("state") || sessionStorage.getItem("state") || ""
    const bankData = localStorage.getItem("bank") || sessionStorage.getItem("bank") || ""

    const jsonData = {
      state: state.split(",").slice(0, -1),
      applicationId,
    }

    if (!bankData.includes("SUPER ADMIN")) {
      jsonData.bank = bankData.split(",").slice(0, -1)
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/auth/case/searchByApplicationId`, jsonData, {
        headers: {
          apikey: API_KEY,
          Authorization: `Bearer ${getCookie("at")}`,
          "Content-Type": "application/json",
        },
      })

      if (response.status === 200) {
        setFirebaseData(response.data || [])
        setTotalFilteredData(response.data || [])
        setTotalRecords(1)
      }
    } catch (error) {
      console.error(error)
      handleNon200Response(error, "1")
    }
  }

  // Get case details for modal
  const getCaseDetails = async (caseData) => {
    const state = localStorage.getItem("state") || sessionStorage.getItem("state") || ""

    const jsonData = {
      state: state.split(",").slice(0, -1),
      applicationId: caseData.applicationid,
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/auth/case/searchByApplicationId`, jsonData, {
        headers: {
          apikey: API_KEY,
          Authorization: `Bearer ${getCookie("at")}`,
          "Content-Type": "application/json",
        },
      })

      if (response.status === 200) {
        const data = response.data
        let rvAddress = ""
        let bvAddress = ""
        let pvAddress = ""

        for (let i = 0; i < data.length; i++) {
          if (data[i].residenceaddress && !rvAddress) {
            rvAddress = data[i].residenceaddress
          }
          if (data[i].officeaddress && !bvAddress) {
            bvAddress = data[i].officeaddress
          }
          if (data[i].permanentaddress && !pvAddress) {
            pvAddress = data[i].permanentaddress
          }
        }

        setModalData({
          applicationId: caseData.applicationid,
          customerName: caseData.customername,
          mobileNumber: caseData.mobilenumber,
          productName: caseData.productname,
          rvAddress,
          bvAddress,
          pvAddress,
        })
        setOpenModal(true)
      }
    } catch (error) {
      console.error(error)
      handleNon200Response(error, "5")
    }
  }

  // Handle agent assignment
  const handleAssignAgent = async (caseData, index) => {
    if (topIndex !== index.toString()) {
      alert("Select Agent")
      return
    }

    if (!selectedMulti || selectedMulti.length === 0) {
      alert("Select Agent")
      return
    }

    const jsonData = {
      agentname: selectedMulti.label.split("-")[1],
      agent: selectedMulti.value,
      agentid: selectedMulti.label.split("-")[0],
      caseAssignedTime: new Date(),
    }

    try {
      const response = await axios.put(`${API_BASE_URL}/auth/case/${caseData._id}`, jsonData, {
        headers: {
          apikey: API_KEY,
          Authorization: `Bearer ${getCookie("at")}`,
          "Content-Type": "application/json",
        },
      })

      if (response.status === 200) {
        fetchList()
        setSelectedMulti([])
        setAgentName("")
        setTopIndex("-1")
        alert("Agent Assigned Successfully!!")
      }
    } catch (error) {
      console.error(error)
      handleNon200Response(error, "4")
    }
  }

  // Handle file upload
  const handleFileChange = (event) => {
    const file = event.target.files?.[0]
    if (file) {
      setSelectedFile(file)
    }
  }

  const handleUpload = async (rowData) => {
    if (!selectedFile) {
      alert("Please select a file first.")
      return
    }

    const fileKey = `${rowData.applicationid}/${selectedFile.name}`
    const contentType = selectedFile.type

    try {
      const fileUrl = await uploadFile(fileKey, selectedFile, contentType)

      const response = await axios.put(
        `${API_BASE_URL}/auth/case/${rowData._id}`,
        {
          manualCreatePDF: fileUrl,
          status: "Completed",
        },
        {
          headers: {
            apikey: API_KEY,
            Authorization: `Bearer ${getCookie("at")}`,
            "Content-Type": "application/json",
          },
        },
      )

      if (response.status === 200) {
        alert("Updated Successfully!")
      } else {
        alert("Failed to update the server.")
      }
    } catch (error) {
      console.error("Error during upload:", error)
      alert("Error during file upload or API request.")
    }
  }

  // Handle appointment time
  const handleAppointTimeChange = (e, caseId) => {
    const value = e.target.value
    setAppointTime((prev) => ({
      ...prev,
      [caseId]: value,
    }))
  }

  const handleUpdateAppointTime = async (caseId) => {
    const time = appointTime[caseId]

    if (!time) {
      alert("Please select a time first.")
      return
    }

    try {
      const response = await axios.put(
        `${API_BASE_URL}/auth/case/${caseId}`,
        {
          appointTime: time,
        },
        {
          headers: {
            apikey: API_KEY,
            Authorization: `Bearer ${getCookie("at")}`,
            "Content-Type": "application/json",
          },
        },
      )

      if (response.status === 200) {
        alert("Appoint Time Updated Successfully!")
      }
    } catch (error) {
      console.error("Error updating appoint time:", error)
    }
  }

  // Handle multi select for agents
  const handleMulti = (selectedOption, index) => {
    setSelectedMulti(selectedOption)
    setTopIndex(index.toString())
  }

  const editInfo = (caseData) => {
    sessionStorage.setItem("caseId", caseData._id)
    window.open("/edit-case")
  }

  // Export to CSV
  const exportToCSV = (fileName) => {
    const dataToExport = firebaseData
    const loans = []

    if (dataToExport.length > 0) {
      for (let i = 0; i < dataToExport.length; i++) {
        const loan = {
          SL_No: i + 1,
          ApplicationId: dataToExport[i].applicationid,
          CustomerName: dataToExport[i].customername,
          Bank: dataToExport[i].bank,
          Product: dataToExport[i].productname,
          CaseType: dataToExport[i].fi,
          TATTime: dataToExport[i].tattime,
          AgentName: dataToExport[i].agentname,
          Status: dataToExport[i].status,
          Allocation_Date_Time: dataToExport[i].createdat?.slice(0, 10) || "",
          Completion_Date_Time: dataToExport[i].submittedat?.slice(0, 10) || "",
          CPV_Status: dataToExport[i].qcpvstatus || "",
          Reject_Reason: dataToExport[i].qrejectreason || "",
        }

        if (sessionStorage.getItem("position") === "Super Admin") {
          loan.Address = dataToExport[i].residenceaddress || dataToExport[i].officeaddress || ""
          loan.Contact_Number = dataToExport[i].mobilenumber
        }
        loans.push(loan)
      }
    }

    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
    const fileExtension = ".xlsx"
    const ws = XLSX.utils.json_to_sheet(loans)
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] }
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" })
    const data = new Blob([excelBuffer], { type: fileType })
    FileSaver.saveAs(data, fileName + fileExtension)
  }

  // Filter data based on search query
  const filteredData = firebaseData.filter((item) => {
    if (!searchQuery) return true
    const searchLower = searchQuery.toLowerCase()
    return (
      item.applicationid?.toLowerCase().includes(searchLower) ||
      item.customername?.toLowerCase().includes(searchLower) ||
      item.bank?.toLowerCase().includes(searchLower) ||
      item.productname?.toLowerCase().includes(searchLower) ||
      item.fi?.toLowerCase().includes(searchLower) ||
      item.agentname?.toLowerCase().includes(searchLower) ||
      item.status?.toLowerCase().includes(searchLower)
    )
  })

  // console.log("sdscd", filteredData);

  return (
    <Container className="page-content" maxWidth="xl">
      <Box sx={{ mb: 3 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href="/">
            Case
          </Link>
          <Typography color="textPrimary">Pending Case</Typography>
        </Breadcrumbs>
      </Box>

      <Card>
        <CardContent>
          {loading && (
            <Box
              sx={{
                position: "absolute",
                top: "20%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}
            >
              <CircularProgress size={80} />
            </Box>
          )}
          {/* Application ID Search */}
          <Box style={{ width: '90%', display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
            {/* <Grid container spacing={2} sx={{ mb: 3 }}> */}
              <Box item xs={12} md={6}>
                <TextField
                  fullWidth
                  placeholder="Application ID"
                  value={applicationId}
                  onChange={(e) => setApplicationId(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={searchByApplicationId}>
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            {/* </Grid> */}

            {/* Search and Export */}
            {/* <Grid container spacing={2} sx={{ mb: 3 }}> */}
              <Box item xs={12} md={6}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<ExportIcon />}
                  onClick={() => exportToCSV("Pending Case")}
                >
                  Export Excel
                </Button>
              </Box>
            {/* </Grid> */}
          </Box>

          {/* Product Filter */}
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <InputLabel>Products</InputLabel>
                  <MaterialUISelect value={product} onChange={(e) => setProduct(e.target.value)}>
                    <MenuItem value="">Select Product</MenuItem>
                    {products.map((prod, index) => (
                      <MenuItem key={index} value={prod.name}>
                        {prod.name}
                      </MenuItem>
                    ))}
                  </MaterialUISelect>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} sx={{ display: "flex", alignItems: "center" }}>
                <Button type="submit" variant="contained" color="primary">
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>

          {/* Date and Bank Filter */}
          <form onSubmit={handleFilter}>
            <Grid container spacing={2} sx={{ mb: 3 }} style={{ marginTop: '10px', marginBottom: '10px' }}>
              {isSuperAdmin ? 
                (<Grid item xs={12} md={3}>
                  <FormControl fullWidth>
                  <InputLabel>Bank</InputLabel>
                  <MaterialUISelect value={bank} onChange={(e) => setBank(e.target.value)}>
                    <MenuItem value="">Select Bank</MenuItem>
                    {banks.map((bankItem, index) => (
                      <MenuItem key={index} value={bankItem.name}>
                        {bankItem.name}
                      </MenuItem>
                    ))}
                  </MaterialUISelect>
                  </FormControl>
                </Grid> ) 
              : null }
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Start Date"
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="End Date"
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={3} sx={{ display: "flex", alignItems: "center" }}>
                <Button type="submit" variant="contained" color="primary">
                  Filter
                </Button>
              </Grid>
            </Grid>
          </form>

          {/* Data Table with Fixed Pagination */}
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            {(filteredData.length === 0 && !loading) && (
              <Container className="page-content" maxWidth="xl">
                <Typography component="div" style={{ position: "relative", minHeight: "100vh" }}>
                  No Data
                </Typography>
              </Container>
            )}
            {/* Table Container with Scroll */}
            <TableContainer>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Sl.No</TableCell>
                    <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Application Id</TableCell>
                    <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Customer Name</TableCell>
                    <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
                      Customer BV/RV Address
                    </TableCell>
                    <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Bank</TableCell>
                    <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Product</TableCell>
                    <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Case Type</TableCell>
                    <TableCell style={{ backgroundColor: "#cce5ff", fontWeight: "bold" }}>Time Since Assign</TableCell>
                    <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Case Created By</TableCell>
                    <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>TAT Time</TableCell>
                    <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Schedule Visit</TableCell>
                    <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Agent</TableCell>
                    <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Status</TableCell>
                    <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
                      Upload Manual Create PDF
                    </TableCell>
                    <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Manually Update</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredData.map((rowData, index) => {
                    // if (!isSuperAdmin && rowData.showToClient !== "YES") {
                    //   return null
                    // }

                    return (
                      <TableRow
                        key={index}
                        className={classes.tableRow}
                      >
                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell>
                          <Button
                            color="primary"
                            onClick={() => getCaseDetails(rowData)}
                            style={{ textAlign: 'start' }}
                          >
                            {rowData.applicationid}
                          </Button>
                          {rowData.salesName && (
                            <Typography variant="caption" style={{ color: "green", display: "block", mt: 1 }}>
                              Sales Agent: {rowData.salesName}
                            </Typography>
                          )}
                        </TableCell>
                        <TableCell>{rowData.customername}</TableCell>
                        <TableCell>{rowData.fi === "BV" ? rowData.officeaddress : rowData.fi === "PV" ? rowData.permanentaddress : rowData.residenceaddress}</TableCell>
                        <TableCell style={{ color: '#FF6666' }}>{rowData.bank}</TableCell>
                        <TableCell>{rowData.productname}</TableCell>
                        <TableCell>{rowData.fi}</TableCell>
                        <TableCell
                          style={{
                            backgroundColor:
                              rowData.caseRunningHour?.hours < 4
                                ? "green"
                                : rowData.caseRunningHour?.hours < 5
                                  ? "orange"
                                  : "red",
                            color: "white",
                          }}
                        >
                          {rowData.caseRunningHour?.label}
                        </TableCell>
                        <TableCell>{rowData.caseCreatedBy}</TableCell>
                        <TableCell>{rowData.tattime}</TableCell>
                        <TableCell>
                          <TextField
                            type="datetime-local"
                            size="small"
                            value={
                              appointTime[rowData._id] ||
                              (rowData.appointTime ? new Date(rowData.appointTime).toISOString().slice(0, 16) : "")
                            }
                            onChange={(e) => handleAppointTimeChange(e, rowData._id)}
                            style={{ marginBottom: '10px' }}
                          />
                          {/* <br /> */}
                          <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={() => handleUpdateAppointTime(rowData._id)}
                            disabled
                          >
                            Update Time
                          </Button>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" style={{ mb: 1, color: '#FF6666' }}>
                            {rowData.agentname}
                          </Typography>
                          <Box style={{ width: 250, mb: 1 }}>
                            <ReactSelect
                              onChange={(event) => handleMulti(event, index)}
                              options={agents}
                              placeholder="Select Agent"
                              styles={customStyles1}
                            />
                          </Box>
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={() => handleAssignAgent(rowData, index)}
                            style={{ marginTop: '10px' }}
                          >
                            Submit
                          </Button>
                        </TableCell>
                        <TableCell>{rowData.status}</TableCell>
                        <TableCell>
                          <input type="file" accept=".pdf" onChange={handleFileChange} style={{ marginBottom: 8 }} />
                          <br />
                          <Button
                            variant="contained"
                            startIcon={<UploadIcon />}
                            onClick={() => handleUpload(rowData)}
                            size="small"
                          >
                            Upload PDF
                          </Button>
                        </TableCell>
                        {/* EDIT */}
                        <TableCell>
                          <IconButton size="small" onClick={() => editInfo(rowData)} sx={{ color: "#1976d2" }}>
                              <EditIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Fixed Pagination at Bottom */}
            <Box
              sx={{
                borderTop: "1px solid #e0e0e0",
                // backgroundColor: "#fafafa",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // minHeight: "80px",
                position: "sticky",
                // bottom: 0,
                // zIndex: 1,
              }}
            >
              <TablePagination
                component="div"
                count={totalRecords}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={pages}
                showFirstButton
                showLastButton
              />
            </Box>
          </Box>
        </CardContent>
      </Card>

      {/* Case Details Modal */}
      <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="md" fullWidth
        PaperProps={{
          style: {
            margin: 0,
            position: 'absolute',
            top: 20,
            // right: 20,
            width: '600px'
          },
        }}
      >
        <DialogTitle disableTypography style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h5" style={{ fontWeight: 'bold', color: '#333' }}>
            {modalData.applicationId}
          </Typography>
          <IconButton onClick={() => setOpenModal(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Typography variant="h6" style={{ fontSize: '0.95rem' }}>Customer Name</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="h6" style={{ fontSize: '0.95rem' }}>: {modalData.customerName}</Typography>
            </Grid>

            <Grid item xs={4}>
              <Typography variant="h6" style={{ fontSize: '0.95rem' }}>Mobile Number</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="h6" style={{ fontSize: '0.95rem' }}>: {modalData.mobileNumber}</Typography>
            </Grid>

            <Grid item xs={4}>
              <Typography variant="h6" style={{ fontSize: '0.95rem' }}>Product</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="h6" style={{ fontSize: '0.95rem' }}>: {modalData.productName}</Typography>
            </Grid>

            {modalData.pvAddress && (
              <>
                <Grid item xs={4}>
                  <Typography variant="h6" style={{ fontSize: '0.95rem' }}>PV Address</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="h6" style={{ fontSize: '0.95rem' }}>: {modalData.pvAddress}</Typography>
                </Grid>
              </>
            )}

            {modalData.rvAddress && (
              <>
                <Grid item xs={4}>
                  <Typography variant="h6" style={{ fontSize: '0.95rem' }}>RV Address</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="h6" style={{ fontSize: '0.95rem' }}>: {modalData.rvAddress}</Typography>
                </Grid>
              </>
            )}

            {modalData.bvAddress && (
              <>
                <Grid item xs={4}>
                  <Typography variant="h6" style={{ fontSize: '0.95rem' }}>BV Address</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="h6" style={{ fontSize: '0.95rem' }}>: {modalData.bvAddress}</Typography>
                </Grid>
              </>
            )}
          </Grid>
        </DialogContent>
      </Dialog>
    </Container>
  )
}

export default PendingCaseNew